// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
if (Number.parseInt === undefined) Number.parseInt = window.parseInt;
if (Number.parseFloat === undefined) Number.parseFloat = window.parseFloat;
import promise from 'es6-promise'
promise.polyfill()
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
import { Lazyload } from 'vant';
Vue.use(Lazyload, {
  lazyComponent: true,
});

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// Vue.user(VueAwesomeSwiper)
// import 'swiper/dist/css/swiper.css'


//引入tinymce富文本编辑框
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// ====================================
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios'
//读取本地json数据了
import VueResource from 'vue-resource'
Vue.use(VueResource)
// ==========图片放大组件
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.min.css';
import 'babel-polyfill';
import './assets/font/font.css'
import './assets/icon/icon.css'
import './assets/index.css'
Vue.use(Viewer);

Viewer.setDefaults({
      'inline':false,//启用 inline 模式
      'button':true, //右上角按钮
      "navbar": false, //底部缩略图
      "title": true, //当前图片标题
      "toolbar": true, //底部工具栏
      "tooltip": true, //显示缩放百分比
      "movable": true, //是否可以移动
      "zoomable": true, //是否可以缩放
      "rotatable": true, //是否可旋转
      "scalable": true, //是否可翻转
      "transition": true, //使用 CSS3 过度
      "fullscreen": true, //播放时是否全屏
      "keyboard": true, //是否支持键盘
      "url": "data-source",
      ready: function (e) {
        console.log(e.type,'组件以初始化');
      },
      show: function (e) {
        console.log(e.type,'图片显示开始');
      },
      shown: function (e) {
        console.log(e.type,'图片显示结束');
      },
      hide: function (e) {
        console.log(e.type,'图片隐藏完成');
      },
      hidden: function (e) {
        console.log(e.type,'图片隐藏结束');
      },
      view: function (e) {
        console.log(e.type,'视图开始');
      },
      viewed: function (e) {
        console.log(e.type,'视图结束');
      },
      zoom: function (e) {
        console.log(e.type,'图片缩放开始');
      },
      zoomed: function (e) {
        console.log(e.type,'图片缩放结束');
      }
    });
// =====================
import {store} from './store'   //引入vuex实例store

// 加入百度统计
router.beforeEach((to, from, next) => {
  if (to.path) {
    if (window._hmt) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})


/*axios全局默认路径*/
// axios.defaults.baseURL = 'https://pizza-app-65e84.firebaseio.com/';
// Vue.prototype.axios = axios;    //全局配置axios（不需要再组件里再次引入，直接可以通过this.axios使用）

/*全局守卫*/
/*router.beforeEach((to,from,next)=>{     // to表示即将进入的路由目标，from表示正要离开的路由，next表示之后跳转的页面
  if (to.path == '/login' || to.path == '/register'){
    next();
  } else {
    alert('还没有登录，请先登录。');
    next('/login')
  }
});*/

Vue.config.productionTip = false
Vue.use(ElementUI)


// 多语言切换相关
import Cookies from 'js-cookie'
import 'normalize.css/normalize.css'
import { i18n } from '@/lang'

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value), // 这里会根据选的语言切换Element-ui的语言
  size: Cookies.get('size') || 'small' // set element-ui default size
})
// 注册lang语言切换为全局组件
import lang from '@/components/pc/lang'
import langMobile from '@/components/mobile/langMobile'
Vue.component('lang', lang)
Vue.component('langMobile', langMobile)


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js